import { render, staticRenderFns } from "./nextpax-rate-plan-modal.vue?vue&type=template&id=d596bf96&"
import script from "./nextpax-rate-plan-modal.vue?vue&type=script&lang=js&"
export * from "./nextpax-rate-plan-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports